import request from '@/utils/request'

export function getSubjectList(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetSubjectList.json',
    method: 'get',
    params
  })
}

export function deleteSubject(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminDeleteSubject.json',
    method: 'post',
    data
  })
}
export function getSubject(params) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminGetSubject.json',
    method: 'get',
    params
  })
}
export function updateContentSubject(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateContentSubject.json',
    method: 'post',
    data
  })
}
export function updateMediaSubject(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminUpdateMediaSubject.json',
    method: 'post',
    data
  })
}
export function createContentSubject(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateContentSubject.json',
    method: 'post',
    data
  })
}
export function createMediaSubject(data) {
  return request({
    url: process.env.BJH_API + '/api/content/pc/AdminCreateMediaSubject.json',
    method: 'post',
    data
  })
}

